
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-properties",
      function () {
        return require("private-next-pages/sell-properties.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-properties"])
      });
    }
  